import ResourceService from "./resource.service";
import Vue from "vue";

class PaymentsService extends ResourceService {
  static get resource() {
    return "payments";
  }

  static summary(params) {
    const url = `${this.resource}/summary`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default PaymentsService;
